// extracted by mini-css-extract-plugin
export default {"buttonContentContainer":"ConfirmSchedule_buttonContentContainer__b1yP5","flexContainer":"ConfirmSchedule_flexContainer__eCAx1","text":"ConfirmSchedule_text__KvBdN"};